import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';
import theme from '../../common/theme';
import { FooterHeight, HeaderHeight } from '../../common/constants';

const MainScreenStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();
  const insets = useSafeAreaInsets();

  return useMemo(
    () =>
      StyleSheet.create({
        loader: {
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
        },
        screen: {
          flex: 1,
        },
        header: {
          padding: scale(8),
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: colors.tertiary2,
          height: scale(HeaderHeight),
          paddingTop: scale(8 + insets.top),
        },
        buttons: {
          flexDirection: 'row',
          flex: 1,
          columnGap: 10,
        },
        content: {
          flex: 1,
          flexDirection: 'row',
          backgroundColor: colors.elevation0,
        },
        sidebarMargin: {
          marginLeft: scale(300),
        },
        layout: {
          flex: 1,
          maxHeight: theme.window.vh - scale(FooterHeight),
        },
        grid: {
          flex: 1,
          alignItems: 'flex-start',
          alignContent: 'flex-start',
          justifyContent: 'flex-start',
          flexDirection: 'row',
        },
        // Updated gridColumn to support two-row layout
        gridColumn: {
          flexDirection: 'column',
          position: 'relative',
          minHeight: scale(300),
          zIndex: 2,
          rowGap: scale(10),
        },
        overlay: {
          ...StyleSheet.absoluteFillObject,
          backgroundColor: colors.overlay,
          opacity: 0.7,
          zIndex: 1,
          pointerEvents: 'auto',
        },
        item: {
          marginRight: scale(10),
          paddingHorizontal: scale(4),
          backgroundColor: colors.elevation1,
        },
        gridItem: {
          paddingHorizontal: scale(4),
          backgroundColor: colors.elevation1,
        },
        rowContainer: {
          position: 'relative',
          width: '100%',
        },
        topRowItem: {
          width: '100%',
        },
        bottomRowItem: {
          position: 'absolute',
          top: '50%',
          width: '100%',
        },
        emptyView: {
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
        },
        emptyText: {
          fontSize: scale(16),
          color: colors.textLight,
          fontFamily: theme.fonts.medium,
        },
        btnSort: {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
        container: {
          flex: 1,
          position: 'relative',
        },
        divider: {
          left: 0,
          right: 0,
          position: 'absolute',
          height: 4,
          width: '100%',
        },
      }),
    [colors, scale, insets],
  );
};

export default MainScreenStyles;
